module.exports = __webpack_public_path__ + "static/kayak-f26e5d0545c9181aeb8a2a87626f0285.jpg";